module.exports = __webpack_public_path__ + "static/truck-586ed02b126b999d777d0e06281226e8.svg";